import { INSURANCE, TAKAFUL } from '@/constants';
import { useInsuranceRoute, useRouteSection } from '@/hooks/useRouteSection';
import { useTranslation } from 'react-i18next';

export const getRouteSectionContent = (title: string) => {
  const { t } = useTranslation();
  const isInsurance = useInsuranceRoute();

  if (isInsurance) {
    return t(title.replace(TAKAFUL, INSURANCE));
  } else {
    return t(title.replace(INSURANCE, TAKAFUL));
  }
};

export const getPercentage = (param: number | undefined) => {
  if (param && !isNaN(param)) {
    return param * 100 + '%';
  } else return '%';
};

export const getSEOTitle = (page: string) => {
  const { t } = useTranslation();
  const section = useRouteSection();

  return [page, '|', t(`header.` + section)].join(' ');
};
